import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from './constants';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { MasterService } from '../services/master.service';
import { SHOW_ERROR } from './http-context.tokens';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  constructor(
    private authenticationService: AuthenticationService,
    private masterService: MasterService,
    private translate: TranslateService,
    private router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const showError = request.context.get(SHOW_ERROR);
    return next.handle(request).pipe(
      catchError((err) => {
        if (showError) {
          if (err.status === 401) {
            this.masterService.showError('Not Authentication');
            localStorage.removeItem(Constants.CurrentUser)
            sessionStorage.removeItem(Constants.CurrentUser)
            this.authenticationService.logout();
            location.reload();
          } else if (err.status === 403) {
            this.masterService.showError('Not permission access');
          } else if (err.status === 500) {
            this.masterService.showError(err.error);
          } else {
            this.masterService.showError(this.translate.instant('RECPTSTR0104'));
          }
          const error = err.error.message || err.statusText;
          return throwError(() => error);
        }
      })
    );
  }

  // private handle401Error(
  //   req: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {
  //   console.log("this.isRefreshing", this.isRefreshing)
  //   if (!this.isRefreshing) {
  //     this.isRefreshing = true;
  //     return this.authenticationService.refreshToken().pipe(
  //       switchMap((newToken: string) => {
  //         if (newToken) {
  //           this.isRefreshing = false;
  //           return next.handle(
  //             this.addTokenHeader(
  //               req,
  //               newToken,
  //               localStorage.getItem('language')
  //             )
  //           );
  //         } else {
  //           console.log('newToken2', newToken);

  //           this.authenticationService.logout();
  //           location.reload();
  //           return throwError(() => 'error');
  //         }
  //       }),
  //       catchError((err) => {
  //         this.isRefreshing = false;
  //         this.authenticationService.logout();
  //         return throwError(() => err);
  //       })
  //     );
  //   } else {
  //     return throwError(() => 'err');
  //   }
  // }
  private addTokenHeader(
    req: HttpRequest<any>,
    token: string,
    language: string | null
  ) {
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        ContentType: 'application/json',
        Language: language || 'ko',
        'x-api-key': this.authenticationService.getApiKey(),
      },
    });
  }
}
